/*
 * File: CreateCoursePeriods.ts
 * Author: Austin Robinson
 * Date Created: 6/11/2023
 * Copyright (c) DrivingDoc 2023
 */
import { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { ErrorResponse, privateApi } from 'api';

export interface CreateCoursePeriodsParams {
  courseSectionId: string;
  start: string;
  end: string;
  openEnrollment?: string;
  closeEnrollment?: string;
  capacity?: number;
  observationCapacity: number;
  waitlistCapacity: number;
  course_period_instructors?: {
    instructor_user_id: string;
  }[];
}

export type CreateCoursePeriodsResult = {
  tenant_id: string;
  id: string;
  course_section_id: string;
  start: Date;
  end: Date;
  open_enrollment?: Date | null;
  close_enrollment?: Date | null;
  capacity?: number | null;
  deleted: boolean;
  created_at?: Date | null;
  updated_at?: Date | null;
  deleted_at?: Date | null;
  created_by?: string | null;
  updated_by?: string | null;
  deleted_by?: string | null;
  observation_capacity?: number | null;
  waitlist_capacity?: number | null;
  waitlist_observation_capacity?: number | null;
}[];

async function createCoursePeriods(params: CreateCoursePeriodsParams[]) {
  // make api call
  const result = await privateApi.post<CreateCoursePeriodsResult>(
    `${import.meta.env.VITE_API_BASE_URL}/courses/periods`,
    params,
    {},
  );

  return result.data;
}

const useCreateCoursePeriods = createMutation<
  CreateCoursePeriodsResult,
  CreateCoursePeriodsParams[],
  AxiosError<ErrorResponse>
>({
  mutationFn: async (variables) => createCoursePeriods(variables),
});

export { createCoursePeriods, useCreateCoursePeriods };
